import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, IInvoicingInformation } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'invoicingInformations'

const getFilter = (axios: IFactoryFunctionRequest<any, any>) => (query?: { optionalFields: string[] }): IFactoryResponse<Array<IInvoicingInformation>, undefined> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/filter`,
    query,
  })
}

const oldFilter = (axios: IFactoryFunctionRequest<Array<Pick<IOffice, '_id' | 'display'>>, undefined>) => ({
  page = 0,
  display = '',
  limit = 30,
}: { page?: number; display?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/filter`,
    query: { page, display, limit },
  })
}

const filter = (axios: IFactoryFunctionRequest<Array<Pick<IOffice, '_id' | 'display'>>, undefined>) => ({
  page = 0,
  display = '',
  limit = 30,
}: { page?: number; display?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, display, limit },
  })
}

const getInvoicingInformations = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const addInvoicingLog = (axios: IFactoryFunctionRequest<any, any>) => ({ data }) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/addLog`,
    data,
  })
}

const createInvoicingInformation = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const updateInvoicingInformation = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteInvoicingInformation = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

const managementList = (axios: IFactoryFunctionRequest<any, any>) => (query: { page?: number; limit?: number; search?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/management/list`,
    query,
  })
}

const softDelete = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/softDelete/${id}`,
  })
}

const registerDirectory = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/registerDirectory/${id}`,
    immediate: false,
  })
}

const getSuperpdpStatus = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}/superpdp/status`,
  })
}

const disconnectSuperpdp = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}/superpdp`,
  })
}

const getById = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getFilter: getFilter(useAxios(axios)),
  oldFilter: oldFilter(useAxios(axios)),
  filter: filter(useAxios(axios)),
  getInvoicingInformations: getInvoicingInformations(useAxios(axios)),
  addInvoicingLog: addInvoicingLog(useAxios(axios)),
  create: createInvoicingInformation(useAxios(axios)),
  update: updateInvoicingInformation(useAxios(axios)),
  delete: deleteInvoicingInformation(useAxios(axios)),
  managementList: managementList(useAxios(axios)),
  softDelete: softDelete(useAxios(axios)),
  registerDirectory: registerDirectory(useAxios(axios)),
  getSuperpdpStatus: getSuperpdpStatus(useAxios(axios)),
  disconnectSuperpdp: disconnectSuperpdp(useAxios(axios)),
  getById: getById(useAxios(axios)),
})
